import { motion } from "framer-motion";
import { Clock, Headphones, Shield, Tv, Wifi, Zap } from "lucide-react";
import WifiIconBlue from "../../assets/imgs/wifi_icon_blue.png";

const benefits = [
  { icon: Wifi, title: "Internet Estável", desc: "99,8% de uptime garantido com fibra óptica real" },
  { icon: Zap, title: "Alta Velocidade", desc: "Planos de até 1 Gbps para toda sua família" },
  { icon: Tv, title: "Streaming & Jogos", desc: "Assista 4K e jogue online sem travamentos" },
  { icon: Headphones, title: "Suporte Rápido", desc: "Equipe técnica pronta para resolver Seu problema" },
  { icon: Shield, title: "Conexão Segura", desc: "Infraestrutura protegida e monitorada 24h" },
  { icon: Clock, title: "Sem Burocracia", desc: "Contrate em minutos direto pelo WhatsApp" },
];

export default function BenefitsSection() {
  return (
    <section id="beneficios" className="py-20 lg:py-28 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="font-poppins font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground mb-4">
              Benefícios que você
              <span className="text-primary"> só encontra aqui</span>
            </h2>
            <p className="text-muted-foreground text-lg mb-10 max-w-lg leading-relaxed">
              Tecnologia de ponta com atendimento humano. Esse é o jeito WebNorte de conectar você.
            </p>

            <div className="grid sm:grid-cols-2 gap-5">
              {benefits.map((b, i) => {
                const Icon = b.icon;
                return (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.1 }}
                    className="flex gap-3 group"
                  >
                    <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors">
                      {typeof b.icon === 'string' ? (
                        <img src={b.icon} alt={b.title} className="h-5 w-5 object-contain" />
                      ) : (
                        <Icon className="h-5 w-5 text-primary" />
                      )}
                    </div>
                    <div>
                      <h3 className="font-poppins font-semibold text-foreground text-sm mb-0.5">
                        {b.title}
                      </h3>
                      <p className="text-xs text-muted-foreground leading-relaxed">{b.desc}</p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="hidden lg:block w-full max-w-md mx-auto lg:max-w-none mt-8 lg:mt-0"
          >
            <div className="relative">
              <img
                src={WifiIconBlue}
                alt="Velocidade e tecnologia"
                className="relative w-full object-cover drop-shadow-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
